import { Pencil, Trash2 } from 'lucide-react';
import React, { useState } from 'react';
import { visiteAPI } from '../../services/api';
import { notificaErrore, messaggioDa } from '../../utils/notifiche';

const CAMPI_PARAMETRI = [
    { key: 'seduta_n', label: 'Seduta n°', type: 'number', placeholder: '1' },
    { key: 'area_trattata', label: 'Area trattata', type: 'text', placeholder: 'Es: Viso' },
    { key: 'n_colpi', label: 'N° colpi', type: 'number', placeholder: '0' },
    { key: 'profondita_mm', label: 'Profondità (mm)', type: 'number', placeholder: '0', step: '0.1' },
    { key: 'energia_j', label: 'Energia (J)', type: 'number', placeholder: '0', step: '0.1' },
    { key: 'durata_impulso_ms', label: 'Durata impulso (ms)', type: 'number', placeholder: '0', step: '0.1' },
    { key: 'frequenza_hz', label: 'Frequenza (Hz)', type: 'number', placeholder: '0', step: '0.1' }
];

const ModuloParametri = ({ modulo, visitaId, onUpdate }) => {
    const [editing, setEditing] = useState(false);
    const [contenuto, setContenuto] = useState(modulo.contenuto || {});

    const handleSave = async () => {
        try {
            await visiteAPI.updateModulo(modulo.id, { titolo: modulo.titolo, contenuto, ordine: modulo.ordine });
            setEditing(false);
            onUpdate();
        } catch (error) { notificaErrore(messaggioDa(error, 'Non riesco a salvare i parametri')); }
    };

    const handleDelete = async () => {
        if (window.confirm('Eliminare questi parametri?')) {
            try {
                await visiteAPI.deleteModulo(modulo.id);
                onUpdate();
            } catch (error) { notificaErrore(messaggioDa(error, 'Non riesco a eliminare i parametri')); }
        }
    };

    const handleChange = (key, value) => {
        setContenuto(prev => ({ ...prev, [key]: value }));
    };

    return (
        <div className="modulo-card modulo-parametri">
            <div className="modulo-header">
                <h3>{modulo.titolo}</h3>
                <div className="modulo-actions">
                    {editing ? (
                        <>
                            <button onClick={handleSave} className="btn-save">Salva</button>
                            <button onClick={() => setEditing(false)} className="btn-cancel">✕</button>
                        </>
                    ) : (
                        <>
                            <button onClick={() => setEditing(true)} className="btn-edit-small"><Pencil size={15} strokeWidth={1.8} aria-hidden="true" /></button>
                            <button onClick={handleDelete} className="btn-delete-small"><Trash2 size={15} strokeWidth={1.8} aria-hidden="true" /></button>
                        </>
                    )}
                </div>
            </div>
            <div className="modulo-content">
                {editing ? (
                    <div className="parametri-grid">
                        {CAMPI_PARAMETRI.map(campo => (
                            <div key={campo.key} className="parametro-field">
                                <label>{campo.label}</label>
                                <input
                                    type={campo.type}
                                    step={campo.step || undefined}
                                    placeholder={campo.placeholder}
                                    value={contenuto[campo.key] || ''}
                                    onChange={(e) => handleChange(campo.key, e.target.value)}
                                />
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="parametri-grid">
                        {CAMPI_PARAMETRI.map(campo => (
                            <div key={campo.key} className="parametro-field parametro-readonly">
                                <label>{campo.label}</label>
                                <span className="parametro-value">
                                    {contenuto[campo.key] || '—'}
                                </span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ModuloParametri;
